import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {AppService} from '@shared/services/app.service';

@Directive({
    // tslint:disable-next-line:directive-selector
  selector: '[confirm]'
})
export class ConfirmDirective {
    @Input() confirmMessage = 'proceed?';
    @Output() confirm = new EventEmitter<any>();

    constructor(private app: AppService) {
    }

    @HostListener('click')
    onClick() {
        this.app.confirm(this.confirmMessage, () => {
            this.confirm.emit();
        }, true);
    }
}
